import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase/config';
import { COLLECTIONS } from '../firebase/collections';
import { ArrowRight } from 'lucide-react';
import SmartImage from './SmartImage';

const CategoriesSection = React.memo(() => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    loadCategories();
  }, []);

  const loadCategories = async () => {
    setLoading(true);
    try {
      const querySnapshot = await getDocs(collection(db, COLLECTIONS.CATEGORIES));
      const categoriesData = [];
      querySnapshot.forEach((doc) => {
        categoriesData.push({ id: doc.id, ...doc.data() });
      });

      // فلترة الفئات النشطة فقط (active === true أو غير موجود)
      const activeCategories = categoriesData.filter(c => c.active !== false);

      setCategories(activeCategories);
    } catch (error) {
      console.error('Error loading categories:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <section className="py-20 px-4 bg-brand-gray-900">
        <div className="max-w-7xl mx-auto text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-orange-600 mx-auto"></div>
        </div>
      </section>
    );
  }

  if (categories.length === 0) return null;

  return (
    <section className="py-12 sm:py-16 md:py-20 px-4 bg-brand-gray-900">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 sm:mb-12 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-2 sm:mb-3 md:mb-4 px-4">
            تصنيفاتنا <span className="text-brand-orange-500">المتنوعة</span>
          </h2>
          <p className="text-gray-400 text-sm sm:text-base md:text-lg px-4">تصفح جميع المنتجات حسب التصنيف</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 sm:gap-4 md:gap-6">
          {categories.map((category) => (
            <div
              key={category.id}
              onClick={() => navigate(`/category/${category.id}`)}
              className="bg-brand-gray-700 rounded-xl md:rounded-2xl p-4 sm:p-6 md:p-8 hover:scale-105 transition-all cursor-pointer border border-brand-gray-600 hover:border-brand-orange-600 group shadow-lg hover:shadow-brand-orange-600/20"
            >
              <div className="bg-brand-orange-600 w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 rounded-lg md:rounded-xl flex items-center justify-center mb-3 sm:mb-4 md:mb-6 group-hover:scale-110 transition overflow-hidden shadow-lg">
                <SmartImage
                  src={category.icon}
                  alt={category.name}
                  size="medium"
                  fallback="📦"
                  className="text-white"
                />
              </div>
              <h3 className="text-base sm:text-lg md:text-2xl font-bold text-white mb-2 md:mb-3">{category.name}</h3>
              {category.description && (
                <p className="text-gray-400 text-xs sm:text-sm md:text-base mb-2 md:mb-4 line-clamp-2">{category.description}</p>
              )}
              <button className="text-brand-orange-500 font-semibold flex items-center gap-1 sm:gap-2 group-hover:gap-3 transition-all text-xs sm:text-sm md:text-base">
                تصفح <ArrowRight className="w-3 h-3 sm:w-4 sm:h-4" />
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
});

export default CategoriesSection;
